export default __webpack_public_path__ + "static/media/igig-logos.d1dbfd0f.png";